import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicDatapathControlUnit = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="DATAPATH AND CONTROL UNIT: HARDWIRED CONTROL UNIT AND MICROPROGRAMMED CONTROL UNIT"
      videos={[
        "https://www.youtube.com/embed/0RMHamOq5FA",
        "https://www.youtube.com/embed/kt-OdnKBbwA",
        "https://www.youtube.com/embed/MxvZQLR6zqM",
        "https://www.youtube.com/embed/fqe8n_7ln2c",
      ]}
      takeaways={[
        { text: "This topic is purely theoretical." },
        { text: "In Datapath, learn about different types of datapath with their diagrams (1-bus, 2-bus, and 3-bus)." },
        { text: "Mainly learn the difference between hardwired control unit and microprogrammed control unit (only theory from this)." },
        { text: "Learn about pros and cons of both hardwired and microprogrammed control unit and how the control unit is different from ALU." },
        { text: "Sometimes, in very rare cases, they can ask about the architectures (block diagrams) of hardwired and microprogrammed control units." },
      ]}
      questions={[]} // Added empty array
      exampleVideos={[]} // Added empty array
    />
);
}

export default ModuleSubtopicDatapathControlUnit;
